import { Button, DatePicker, Form, Row, Space } from 'antd';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getOccupationByBranch } from '../../../../appRedux/actions/Reports';
import { buttonLabel, dateFormat, formConfig } from '../../../../constants';

export const OccupationByBranchFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;

  const onSubmit = (values) => {
    if (values.dates)
      values.dates = values.dates.map((date) =>
        moment(date)?.format(dateFormat)
      );
    dispatch(getOccupationByBranch(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="dates">
            <RangePicker format={dateFormat} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
